import { BaseService } from '../base';

export interface Role {
  id: string;
  name: string;
  description?: string;
  colorScheme?: string;
}

export interface RolesResponse {
  roles: Role[];
  total: number;
}

export class RolesService extends BaseService {
  private customBaseUrl = import.meta.env.VITE_API_URL;

  constructor() {
    super();
  }

  async getRoles(): Promise<{
    success: boolean;
    data?: RolesResponse;
    error?: string;
  }> {
    try {
      const response = await this.get(
        '/portal/v1/identity/users/roles',
        {},
        this.customBaseUrl
      );
      return await this.handleJsonResponse<RolesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro de conexão',
      };
    }
  }

  async getRoleById(
    roleId: string
  ): Promise<{ success: boolean; data?: Role; error?: string }> {
    try {
      const response = await this.get(
        `/portal/v1/identity/users/roles/${roleId}`,
        {},
        this.customBaseUrl
      );
      return await this.handleJsonResponse<Role>(response);
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro de conexão',
      };
    }
  }
}

export const rolesService = new RolesService();
